var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapbox = function SvgMapbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 1024 1024"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512
  })), /*#__PURE__*/React.createElement("path", {
    d: "M512 256c-141.39 0-256 114.61-256 256s114.61 256 256 256 256-114.61 256-256-114.61-256-256-256m121.52 318.78c-87.52 87.54-243.9 59.6-243.9 59.6S361.4 478.3 449.23 390.47c48.67-48.67 129.3-46.65 180.27 4s52.7 131.6 4 180.27zM541.37 406l-25.05 51.55-51.55 25.05 51.55 25.05 25.05 51.55 25.05-51.55L618 482.63l-51.55-25.05z",
    style: {
      fill: "#fff"
    }
  }));
};
export { SvgMapbox as ReactComponent };
export default __webpack_public_path__ + "3e71e698510ae04b163ad4bce1a42d4f.svg";